/** Transloco prefix for shared document attach / upload / library copy. */
export const DOCUMENT_ATTACH_I18N_SCOPE = 'ACTIVITY_BROWSER.DOCUMENT_ATTACH' as const;
